import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResizedDirective } from "./directives/resized.directive";

@NgModule({
    imports: [CommonModule, ResizedDirective],
    exports: [
        ResizedDirective,
    ],
})
export class SharedUiResizeObserverModule {}
